<div class="login_wrapper">
    <img src="/assets/images/logo-mark.svg" class="login_logo" alt="" />

    <div class="login_content">
        <div class="login_box">
            <div class="login_box_inner" *ngIf="isSignup">
                <img src="/assets/images/logo.svg" class="login_logo" alt="" />
                <p class="welcome_text_login">Create your account</p>
                <p class="welcome_sub_text_login">
                    Join Phonetik and get started in minutes.
                </p>
                <hr style="border-color: #2a3238" />
                <form [formGroup]="signUpForm">
                    <div class="login_control mb_24">
                        <p class="login_password_label">Email ID</p>
                        <input
                            type="text"
                            class="form-control login_form_control"
                            formControlName="email"
                            name="email"
                            placeholder="Enter your Email ID"
                        />
                        <div
                            *ngIf="
                                signUpForm.get('email')?.invalid &&
                                (signUpForm.get('email')?.dirty ||
                                    signUpForm.get('email')?.touched)
                            "
                            class="text-danger"
                        >
                            <!-- <p *ngIf="signUpForm.get('email')?.hasError('required')">Email is required.</p> -->
                            Email is required.
                        </div>
                    </div>
                    <div class="login_control mb_24">
                        <p class="login_password_label">Password</p>
                        <input
                            type="password"
                            [type]="passwordVisible ? 'text' : 'password'"
                            formControlName="password"
                            class="form-control login_form_control"
                            placeholder="Enter new password"
                        />
                        <div
                            *ngIf="
                                signUpForm
                                    ?.get('password')
                                    ?.hasError('required') &&
                                (signUpForm?.get('password')?.dirty ||
                                    signUpForm?.get('password')?.touched)
                            "
                            class="text-danger"
                        >
                            <p>Password is required.</p>
                        </div>

                        <div
                            *ngIf="
                                signUpForm
                                    ?.get('password')
                                    ?.hasError('minlength')
                            "
                            class="text-danger"
                        >
                            <p>
                                Password must have a minimum length of 8
                                characters.
                            </p>
                        </div>
                        <div
                            *ngIf="
                                signUpForm
                                    ?.get('password')
                                    ?.hasError('missingCapitalLetter')
                            "
                            class="text-danger"
                        >
                            <p>
                                Password must contain at least one capital
                                letter.
                            </p>
                        </div>
                        <div
                            *ngIf="
                                signUpForm
                                    ?.get('password')
                                    ?.hasError('missingNumber')
                            "
                            class="text-danger"
                        >
                            <p>Password must contain at least one number.</p>
                        </div>
                        <div
                            *ngIf="
                                signUpForm
                                    ?.get('password')
                                    ?.hasError('missingSpecialCharacter')
                            "
                            class="text-danger"
                        >
                            <p>
                                Password must contain at least one special
                                character.
                            </p>
                        </div>

                        <i
                            class="fa fa-eye-slash password_eye_login"
                            aria-hidden="true"
                            *ngIf="!passwordVisible"
                            (click)="togglePasswordVisibility()"
                        ></i>
                        <i
                            class="fa fa-eye password_eye_login"
                            aria-hidden="true"
                            *ngIf="passwordVisible"
                            (click)="togglePasswordVisibility()"
                        ></i>
                    </div>
                    <div class="login_control mb_75">
                        <p class="login_password_label">Confirm Password</p>
                        <input
                            type="password"
                            [type]="passwordVisible1 ? 'text' : 'password'"
                            formControlName="confirmpassword"
                            class="form-control login_form_control"
                            placeholder="Enter new password"
                        />
                        <div
                            *ngIf="
                                signUpForm
                                    .get('confirmpassword')
                                    ?.hasError('required') &&
                                signUpForm.get('confirmpassword')?.touched
                            "
                            class="text-danger"
                        >
                            Confirm Password is required.
                        </div>
                        <div
                            *ngIf="
                                signUpForm.hasError('passwordMismatch') &&
                                signUpForm.get('confirmpassword')?.touched
                            "
                            class="text-danger"
                        >
                            Passwords do not match.
                        </div>
                        <i
                            class="fa fa-eye-slash password_eye_login"
                            aria-hidden="true"
                            *ngIf="!passwordVisible1"
                            (click)="togglePasswordVisibility1()"
                        ></i>
                        <i
                            class="fa fa-eye password_eye_login"
                            aria-hidden="true"
                            *ngIf="passwordVisible1"
                            (click)="togglePasswordVisibility1()"
                        ></i>
                    </div>
                </form>
                <div class="login_form_footer">
                    <a routerLink="/login" class="have_account">
                        Already have an account? Login</a
                    >
                    <div *ngIf="isClicked" class="loader_div">
                        <button
                            class="btn continue_login_btn_forgot"
                            type="submit"
                        >
                            <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Loading...
                        </button>
                    </div>
                    <button
                        *ngIf="!isClicked"
                        (click)="signUp()"
                        class="btn continue_login_btn"
                    >
                        Sign Up
                    </button>
                    <!-- <a [routerLink]="['./']" class="btn invitation_text_btn">I have an Invitation Code</a> -->
                </div>
            </div>
        </div>
    </div>
</div>

<app-pop-up></app-pop-up>
